import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=54225718&scoped=true&"
import script from "./Cart.js?vue&type=script&lang=js&"
export * from "./Cart.js?vue&type=script&lang=js&"
import style0 from "./Cart.scss?vue&type=style&index=0&id=54225718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54225718",
  null
  
)

export default component.exports